// extracted by mini-css-extract-plugin
module.exports = {"Photo":"photoList_Photo__3gyCo","GalleryContainer":"photoList_GalleryContainer__1ZvLv"};